import type { ReactNode } from 'react';
import { BrandMark } from '../../components/BrandMark';
import styles from './onboarding.module.css';

type StepState = 'active' | 'done' | 'todo';

function StepChip({ number, label, state }: { number: string; label: string; state: StepState }) {
  return (
    <li className={styles.chip} data-state={state} aria-current={state === 'active' ? 'step' : undefined}>
      <span className={styles.chipNumber}>{state === 'done' ? '✓' : number}</span>
      <span>{label}</span>
    </li>
  );
}

export function OnboardingFrame({ step, skip, children }: { step: 1 | 2; skip: ReactNode; children: ReactNode }) {
  return (
    <div className={styles.page}>
      <header className={styles.top}>
        <BrandMark />
        <ol className={styles.stepper} aria-label="Onboarding steps">
          <StepChip number="01" label="SET YOUR FTP" state={step === 1 ? 'active' : 'done'} />
          <StepChip number="02" label="BRING YOUR RIDES" state={step === 2 ? 'active' : 'todo'} />
        </ol>
        {skip}
      </header>
      <main className={styles.body} data-step={step}>{children}</main>
    </div>
  );
}
